import { INoticeConfig } from "@/domain/entities/user/user.types";

export class NoticeConfig implements INoticeConfig {
  receiveNotice: boolean;

  constructor(data: INoticeConfig) {
    this.receiveNotice = data.receiveNotice;
  }
}
